var ElecboyTheme = window.ElecboyTheme || {};
ElecboyTheme.pdp = function(){

	function init(){
		console.log('Elecboy-PDP init()');

		if ( typeof Stickyfill !== 'undefined' ) {
			// polyfill CSS sticky
			var elements = document.querySelectorAll('.sticky');
			Stickyfill.add(elements);
		}

		mediaSetup();
		imageZoomInit();
		layoutAdjustment();
		initSupplierPremiumPopup();
		initHardBundle();

		pubsub.subscribe('pdp.variantChange', variantChange);
		pubsub.subscribe('pdp.variantChange', badgeUpdateHandler);
		pubsub.subscribe('pdp.variantChange', deliveryMethodsUpdateHandler);
		pubsub.subscribe('pdp.variantChange', largeHomeApplianceUpdateHandler);
		pubsub.subscribe('pdp.variantChange', productMessageUpdateHandler);
		pubsub.subscribe('pdp.variantChange', offlineStoresStockUpdateHandler);
		pubsub.subscribe('pdp.variantChange', storeInquiryButtonHandler);
		pubsub.subscribe('pdp.variantChange', initHardBundle);

		$('.brick-indicators').removeClass('hide');
		overrideGrowaveStyles();
	}

	function variantChange(_event, data){
		var variant = data.variant;
		var variantSKU = '';
		var variantImg = '';

		if (variant.featured_image){
			variantSKU = variant.sku;
			variantImg = variant.featured_image.src.split('/').pop().split('?').shift();
		} else {
			variantSKU = 'placeholder';
			for (var i=0; i<pdpImgSlides.length; i++) {
				if (pdpImgSlides[i].sku == variantSKU) {
					variantImg = pdpImgSlides[i].dataSrc;
				}
			}
		}
		updateProductSlide(variantSKU);
		$('#pdp-sku').text(data.variant.sku);
	}

	function storeInquiryButtonHandler(_event, data) {
		var $whatsappBtn = $('.btn-whatsapp');
		if (!$whatsappBtn.data('in-whitelist')) {
			$whatsappBtn.toggleClass('hide', !data.mf.isOfflineStoreOnly);
		}
	}

	function badgeUpdateHandler(_event, data){
		var domBrickIndicatorsDiv = document.querySelector('.brick-indicators');
		if ( !domBrickIndicatorsDiv ) return;
		domBrickIndicatorsDiv.innerHTML = '';

		var variant = data.variant,
			isCatalogSales = data.mf.isCatalogSales,
			productSource = data.mf.productSource,
			preOrderStart = data.mf.preOrderStart,
			preOrderEnd = data.mf.preOrderEnd,
			purchaseGuarantee = data.mf.isTenDayGuarantee,
			tpl = '',
			isPreOrder = false;
		;
		if( preOrderStart !== '' && preOrderEnd !== '') {
			if (ElecboyTheme.isWithinPeriod( preOrderStart, preOrderEnd )) {
				isPreOrder = true;
			}
		}
		if (!variantMF[variant.sku+""].isReleased && !isPreOrder) {
			tpl = document.querySelector('#tpl-badge-releaseSoon').content.cloneNode(true);
			domBrickIndicatorsDiv.appendChild(tpl);
		} else if ( variantMF[variant.sku+""].available === "true" ) {
			// check pre-order
			if ( isPreOrder ) {
				tpl = document.querySelector('#tpl-badge-preorder').content.cloneNode(true);
				domBrickIndicatorsDiv.appendChild(tpl);
			} else if ( isCatalogSales ) {
				if (variantMF[variant.sku+""].isOfflineStoreOnly) {
					tpl = document.querySelector('#tpl-badge-storeOnly').content.cloneNode(true);
					domBrickIndicatorsDiv.appendChild(tpl);
				}
				tpl = document.querySelector('#tpl-badge-catalogSale').content.cloneNode(true);
				domBrickIndicatorsDiv.appendChild(tpl);
			} else {
				tpl = document.querySelector('#tpl-badge-available').content.cloneNode(true);
				domBrickIndicatorsDiv.appendChild(tpl);
			}
		} else {
			if ( !variantMF[variant.sku+""].isFirstReceived ) {
				tpl = document.querySelector('#tpl-badge-releaseSoon').content.cloneNode(true);
				domBrickIndicatorsDiv.appendChild(tpl);
			} else {
				if (variantMF[variant.sku+""].isOfflineStoreOnly) {
					tpl = document.querySelector('#tpl-badge-storeOnly').content.cloneNode(true);
					domBrickIndicatorsDiv.appendChild(tpl);
				} else {
					tpl = document.querySelector('#tpl-badge-unavailable').content.cloneNode(true);
					domBrickIndicatorsDiv.appendChild(tpl);
				}
			}
		}

		// check local-athorized / parallel
		switch ( parseInt(productSource) ){
			case 1:
				tpl = document.querySelector('#tpl-badge-productSource-local-authorized').content.cloneNode(true);
				domBrickIndicatorsDiv.appendChild(tpl);
				break;
			case 2:
			case 3:
				tpl = document.querySelector('#tpl-badge-productSource-parallel').content.cloneNode(true);
				domBrickIndicatorsDiv.appendChild(tpl);
				break;			
			default:
				break;
		}
		if (purchaseGuarantee) {
			tpl = document.querySelector('#tpl-badge-purchase-guarantee').content.cloneNode(true);
			domBrickIndicatorsDiv.appendChild(tpl);
		}
	}

	function deliveryMethodsUpdateHandler(_event, data) {

		var deliveryMethods = data.mf.deliveryMethod.split(',')
			.map((str) => str.trim())
			.filter((str) => !!str);
		if (data.mf.isCatalogSales && data.mf.productClass === 'Class VC') {
			deliveryMethods = ['HOMED'];
		}
		if (data.mf.isVirtualProduct || data.mf.isFreeGift) {
			deliveryMethods = ['HOMED','CIRCLE K','LOCKER','SF LOCKER','STORE'];
		}
		$('.product-delivery-info').find('.cur-question').each(function() {
			var deliveryMethod = $(this).data('delivery-method');
			var available = deliveryMethods.includes(deliveryMethod);
			var t = data.translations.deliveryMethods[deliveryMethod];
			$(this).find('.elecboy-tooltip').html(available ? t.tooltips.available : t.tooltips.unavailable);
			$(this).find('img')
				.attr('src', available ? t.imageSrc.available : t.imageSrc.unavailable)
				.attr('alt', t.label);
		});
	}

	function largeHomeApplianceUpdateHandler(_event, data){
		var lang = $('html').attr('lang') === 'en' ? 'en' : 'tc';
		var productType = data.product_type;
		var hasInstallation = data.mf.hasInstallation;
		var installationOptions = data.mf.installationOptions;
		var hasTakeback = data.mf.hasTakeback;
		var takebackOptions = data.mf.takebackOptions;

		var $widgetDiv = $('.product-lha').first();
		if (!productType && !hasInstallation && !hasTakeback) {
			$widgetDiv && $widgetDiv.remove();
			return;
		}
		if ( !$widgetDiv ) {
			$widgetDiv.html($('#tpl-product-lha').html());
		}
		var $containerDiv = $widgetDiv.find('.product-lha__container').first();
		$containerDiv.find('.product-lha__installation').remove();
		$containerDiv.find('.product-lha__takeback').remove();

		if (hasInstallation) {
			$containerDiv.append($('#tpl-product-lha__installation').html());
			
			var $installationUl = $containerDiv.find('.product-lha__installation>ul').first();
			$installationUl.html('');
			installationOptions.forEach((installationOption) => {
				const title = lang === 'en'
					? (installationOption.titleEN || '')
					: (installationOption.titleZT || '');
				const description = lang === 'en'
					? (installationOption.descEN || '')
					: (installationOption.descZT || '');
				const tnc = installationOption.sku === '13038067'
					? ''
					: '&nbsp;' + window.lang['lha-installation-tnc-html'];
				$installationUl.append($('#tpl-product-lha__installation-option').html()
					.replace('__value__', installationOption.sku)
					.replace('__title__', `${title}${tnc}`)
					.replace('__description__', description)
					.replace('__price__', window.ElecboyTheme.lha.installation[installationOption.sku]));
			});
		} else {
			$containerDiv.find('.product-lha__installation').remove();
		}
		if (hasTakeback) {
			$containerDiv.append($('#tpl-product-lha__takeback').html());
			var $takebackUl = $containerDiv.find('.product-lha__takeback>ul').first();
			$takebackUl.html('');
			takebackOptions.forEach((takebackOption) => {
				const title = lang === 'en'
					? (takebackOption.titleEN || '')
					: (takebackOption.titleZT || '');
				const description = lang === 'en'
					? (takebackOption.descEN || '')
					: (takebackOption.descZT || '');				
				const tnc = takebackOption.sku === '11778512'
					? ''
					: takebackOption.sku === '11697000'
						? '&nbsp;' + window.lang['lha-takeback-weee-tnc-html']
						: '&nbsp;' + window.lang['lha-takeback-default-tnc-html'];
				$takebackUl.append($('#tpl-product-lha__takeback-option').html()
					.replace('__value__', takebackOption.sku)
					.replace('__title__', `${title}${tnc}`)
					.replace('__description__', description)
					.replace('__price__', window.ElecboyTheme.lha.takeback[takebackOption.sku]));
			});
		} else {
			$containerDiv.find('.product-lha__takeback').remove();
		}
	}

	function productMessageUpdateHandler(_event, data) {
		var $root = $('#shopify-section-product-messages');
		Object.keys(ElecboyTheme.productMessages || {}).forEach(function(blockId) {
			$(`.product-message[data-block-id=${blockId}]`).remove();
			var blockSettings = window.ElecboyTheme.productMessages[blockId];
			var metafield = data.mf.productMessages[blockSettings.metafield];
			if (metafield) {
				var description = blockSettings.description;
				Object.entries(metafield).forEach(([key, val]) => {
					description = description.replaceAll(`__${key}__`, val);
				});
				$root.append(`
				<div class="product-message" data-block-id="${blockId}">
					${blockSettings.title ? `<p style="margin-bottom:9px;">${blockSettings.title}:</p>` : '' }
					<div class="product-message__content">
						${blockSettings.iconSrc ? `<img loading="lazy" width="24" height="24" src="${blockSettings.iconSrc}" alt="" />` : ''}
					<div class="product-message__description">${description}</div>
				</div>
				`);
			}
		});
	}

	function offlineStoresStockUpdateHandler(_event, data) {
		var $root = $('#product-offline-stores-stock');
		$root.toggleClass('hide', window.hideOfflineStoreStocksSkus.includes(data.variant.sku));
		var $storeList = $root.find('.store-list');
		if ($storeList.length > 0) {
			$storeList.empty();
			var lang = $('html').attr('lang') === 'en' ? 'en' : 'tc';
			(data.mf.offlineStocks || []).forEach(function(store) {
				const storeName = lang === 'en' ? store.name_eng : store.name_chi;
				const hasStock = store.has_stock.toUpperCase();
				if(hasStock === 'PS') {
					$storeList.append(`<p>${storeName}:&nbsp;<span class="bold">${window.lang['offline-store-stock']['ps']}</span></p>`);
				} else if(hasStock === 'PW') {
					$storeList.append(`<p>${storeName}:&nbsp;<span class="bold">${window.lang['offline-store-stock']['pw']}</span></p>`);
				} else if(hasStock === 'Y') {
					$storeList.append(`<p>${storeName}:&nbsp;<span class="bold" style="color: green">${window.lang['offline-store-stock']['y']}</span></p>`);
				} else if(hasStock === 'YW') {
					$storeList.append(`<p>${storeName}:&nbsp;<span class="bold" style="color: green">${window.lang['offline-store-stock']['yw']}</span></p>`);
				} else if(hasStock === 'N') {
					$storeList.append(`<p>${storeName}:&nbsp;<span class="bold">${window.lang['offline-store-stock']['n']}</span></p>`);
				} else if(hasStock === 'YD') {
					$storeList.append(`<p>${storeName}:&nbsp;<span class="bold" style="color: green">${window.lang['offline-store-stock']['yd']}</span></p>`);
				} else if(hasStock === 'ND') {
					$storeList.append(`<p>${storeName}:&nbsp;<span class="bold">${window.lang['offline-store-stock']['nd']}</span></p>`);
				} else if(hasStock === 'WD') {
					$storeList.append(`<p>${storeName}:&nbsp;<span class="bold" style="color: green">${window.lang['offline-store-stock']['wd']}</span></p>`);
				} else {
					$storeList.append(`<p>${storeName}:&nbsp;<span>${window.lang['offline-store-stock']['n']}</span></p>`);
				}
			});
		}
	}


	function layoutAdjustment(){
		$('.btn-scroll-to-offline-store-stocks').on('click', function(e){
			e.preventDefault();
			$('body,html').animate({
				scrollTop: $('#product-offline-stores-stock').position().top
			}, 1200);
			return false;
		});

		$('.pdp-scroll-to-tabs').on('click', function(e){
			e.preventDefault();
			$('body,html').animate({
				scrollTop: $('.pdp-offscreen').position().top
			}, 1200);
			return false;
		});

		$(window).on('resize', function() {
			if ( $('.product-info').length ) {
				$('.pdp-wrapper').css('min-height',$('.product-info').height());
			}	
		}).resize();
	}

	function mediaSetup(){
		$('.pdp-media-nav-wrapper').on('click', 'a', function(e){
			e.preventDefault();
			$('.pdp-media-nav-wrapper a').removeClass('selected');
			$(this).addClass('selected');
			var $targetElm = $($(this).attr('href'));
			if( $targetElm.length ) {
				$('body,html').stop().animate({
					scrollTop: $targetElm.first().offset().top - $('.site-header-container').outerHeight() - $('.breadcrumb').outerHeight()
				}, 600);
			}
			return false;
		});
	}

	function updateProductSlide(sku){
		var $view = $('.more-views');
		var flkity = Flickity.data($view.get(0));
		flkity && flkity.destroy();

		var $toShowSlides = $view.find('.slide[data-sku="' + sku + '"]');
		var $toHideSlides = $view.find('.slide[data-sku!="' + sku + '"]');
		$toShowSlides.addClass('visible');
		$toHideSlides.removeClass('visible');
		$toShowSlides.find('.img-ar').removeClass('hide');
		$toHideSlides.find('.img-ar').addClass('hide');
		$('.pdp-media-nav-wrapper .img-ar[data-sku="' + sku +'"]').removeClass('hide');
		$('.pdp-media-nav-wrapper .img-ar[data-sku!="' + sku +'"]').addClass('hide');
		
		if (flkity) {
			flkity = new Flickity($view.get(0), $view.data('flickity'));
			flkity.select(0);	
		}
	}

	function imageZoomInit(){
		$('.more-views img').on('click', function(e){
			var
				pswpElement = document.querySelectorAll('.pswp')[0],
				items = [],
				sku = $(this).parents('[data-sku]').data('sku'),
				seq = $(this).data('seq'),
				$body = $('body');

			$(this).parents('.more-views').find('img').each(function(){
				var $_this = $(this);
				if ($_this.parents('[data-sku]').data('sku') === sku) {
					items.push({
						src: $_this.data('original-src'),
						w: $_this.data('max-width'),
						h: $_this.data('max-height'),
						initialZoomLevel: 0.65,
					});	
				}
			});

			// Initializes and opens PhotoSwipe
			window.pdpZoomGallery = new PhotoSwipe(pswpElement, false, items, {
	          index: seq-1,
	          showHideOpacity: true,
	          showAnimationDuration: 500,
	          loop: false,
	          history: false,
	          closeOnVerticalDrag: false,
	          allowPanToNext: false,
	          pinchToClose: false,
	          //errorMsg: '<p class="pswp__error-msg">' + window.languages.productImageLoadingError + '</p>',
	          //scaleMode: 'zoom',
	          getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
	            return 1.6;
	          }
	          // getThumbBoundsFn: function getThumbBoundsFn(index) {
	          //   // var thumbnail = _this10.element.querySelector('.Product__Slideshow .Carousel__Cell[data-image-media-position="' + parseInt(index) + '"] img'),
	          //   //     pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
	          //   //     rect = thumbnail.getBoundingClientRect();

	          //   // return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
	          // }
	        });
			window.pdpZoomGallery.init();
			window.pdpZoomGallery.listen('close', function(){
				$('body').off('pswpTap');
        		window.pdpZoomGallery = null;
			});

			$body.on('pswpTap', '.pswp__button--close', pdpZoomGallery.close);
			$body.on('pswpTap', '.pswp__button--arrow--left', pdpZoomGallery.prev);
			$body.on('pswpTap', '.pswp__button--arrow--right', pdpZoomGallery.next);
		});
	}

	function initSupplierPremiumPopup() {
		$('.fpu-supplier-premium-popup').parents('.theme-popup').detach().appendTo($('body'));
		$('#pdp-supplier-premium a').on('click', function(e) { 
			e.preventDefault();
			var i = $(this).data('index');
			var variantId = $(this).data('variant-id');
			gred.showPopup('.fpu-supplier-premium-'+i+'-popup[data-variant-id="'+variantId+'"]');
		});
	}

  function overrideGrowaveStyles() {
    function attachCustomQAFormStyle() {
      var isInitialized = false;
      setInterval(function() {
        if (isInitialized) {
          return;
        }
        var $el = $('.gw-reviews-form-modal-widget-placeholder');
        if ($el.length > 0) {
          var root = $el.get(0).shadowRoot;
          if (root) {
            var lang = window.LangShop.getCurrentLanguage().code;
            const sheet = new CSSStyleSheet();
            if (window.customer) {
                sheet.replaceSync(`
.gw-modal-dialog {
  @media screen and (max-width: 900px) {
    margin-bottom: 120px !important;
  }
}
.gw-modal__content {
  align-items: center !important;
}
.gw-rv-form-nav__right .gw-button{
  min-width: 80px !important;
}
.gw-qa-form-result__header {
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
}
.gw-qa-form-result__success-subtitle {
  display: none !important;
}
            `);
            } else {
            sheet.replaceSync(`
.gw-modal__content {
  align-items: center !important;
}
.gw-qa-form-modal__form {
  height: 180px !important;
}
.gw-qa-form-nav,
.gw-qa-form-question__inputs {
  display: none !important;
}
.gw-qa-form-question__title a {
  color: #FF0055;
}
.gw-qa-form-question__title a:hover {
  opacity: 0.7;
}
                `);
            }
            root.adoptedStyleSheets.push(sheet);
            if (!window.customer) {
              var titleEl = root.querySelector('.gw-qa-form-question__title');
              titleEl.innerHTML = lang === 'en'
                  ? 'Please <a href="/en/account/register">register</a> or <a href="/en/account/login">login</a> first' 
                  : '請先<a href="/account/register">註冊</a>或<a href="/account/login">登入</a>';
            }
          }
          isInitialized = true;
        } ;
      }, 500);
    }

    function attachCustomReviewFormStyle() {
      var isInitialized = false;
      setInterval(function() {
        if (isInitialized) {  
          return;
        }
        var $el = $('.gw-reviews-form-modal-widget-placeholder');
        if ($el.length > 0) {
          var root = $el.get(0).shadowRoot;
          if (root) {
            var lang = window.LangShop.getCurrentLanguage().code;
            const sheet = new CSSStyleSheet();
            if (window.customer) {
                sheet.replaceSync(`
.gw-modal-dialog {
  @media screen and (max-width: 900px) {
    margin-bottom: 120px !important;
  }
}
.gw-modal__content {
  align-items: center !important;
}
.gw-rv-form-reward__box {
  display: none !important;
}
.gw-rv-form-photo__subtitle {
  font-size: 0 !important;
}
.gw-rv-form-nav__right .gw-button{
  min-width: 80px !important;
}
            `);
            } else {
            sheet.replaceSync(`
.gw-modal__content {
  align-items: center !important;
}
.gw-rv-form-modal__steps {
  height: 180px !important;
}
.gw-rv-form-rating__input-block {
  display: none !important;
}
.gw-rv-form-rating__title a {
  color: #FF0055;
}
.gw-rv-form-rating__title a:hover {
  opacity: 0.7;
}
                `);
            }
            root.adoptedStyleSheets.push(sheet);
            if (!window.customer) {
              var titleEl = root.querySelector('.gw-rv-form-rating__title');
              titleEl.innerHTML = lang === 'en'
                  ? 'Please <a href="/en/account/register">register</a> or <a href="/en/account/login">login</a> first' 
                  : '請先<a href="/account/register">註冊</a>或<a href="/account/login">登入</a>';
            }
            isInitialized = true;
          }
        }
      }, 500);
    }
    function overrideReviewStyles() {
      var isListInitialized = false;
      var isFormsInitialized = false;
      setInterval(function() {
        if (!isListInitialized) {
          var $root = $('.gw-rv-main-widget-placeholder');
          if ($root.length > 0) {
            var root = $root.get(0).shadowRoot;
            if (root) {
              var sheet = new CSSStyleSheet();
              sheet.replaceSync(`
  .gw-text {
  color: #2d2d2d !important;
  }
  button {
  border-radius: 3px !important;
  }
  .gw-btn.gw-btn--mode-primary {
  background: #2d2d2d !important;
  }
  .gw-btn.gw-btn--mode-primary .gw-text {
  color: #ffffff !important;
  }
  .gw-btn.gw-btn--mode-primary:hover {
  background: #575757 !important;
  }
  .gw-btn.gw-btn--mode-primary:hover .gw-text {
  color: #ffffff !important;
  }
  .gw-btn.gw-btn--mode-secondary {
  border: 1px solid #e5e5e5 !important;
  }
  .gw-btn.gw-btn--mode-secondary .gw-text {
  color: #2d2d2d !important;
  }
  .gw-btn.gw-btn--mode-secondary:hover {
  border: 1px solid #2d2d2d !important;
  }
  .gw-btn.gw-btn--mode-secondary:hover .gw-text {
  color: #2d2d2d !important;
  }
  .gw-tooltip__wrapper .gw-text {
  color: #ffffff !important;
  }
                `);
              root.adoptedStyleSheets.push(sheet);
              isListInitialized = true;
            }
          }
        }
        if (!isFormsInitialized) {
          var $root = $('.gw-reviews-form-modal-widget-placeholder');
          if ($root.length > 0) {
            var root = $root.get(0).shadowRoot;
            if (root) {
              var sheet = new CSSStyleSheet();
              sheet.replaceSync(`
button {
  border-radius: 3px !important;
}
.gw-rv-toggle-vote,
.gw-empty-state__icon,
.gw-empty-state__footer {
  display: none !important;
}
.gw-rv-item-reply__shopName {
  font-weight: bold !important;
  font-size: calc(var(--txt-body) * 0.875) !important;
}
.gw-rv-listing-layout__buttons {
  flex-direction: row-reverse;
}
.gw-empty-state__title {
  margin: 1em 0 !important;
}
.gw-btn.gw-btn--mode-primary {
  background: #2d2d2d !important;
}
.gw-btn.gw-btn--mode-primary .gw-text {
  color: #ffffff !important;
}
.gw-btn.gw-btn--mode-primary:hover {
  background: #575757 !important;
}
.gw-btn.gw-btn--mode-primary:hover .gw-text {
  color: #ffffff !important;
}
.gw-btn.gw-btn--mode-secondary {
  border: 1px solid #e5e5e5 !important;
}
.gw-btn.gw-btn--mode-secondary .gw-text {
  color: #2d2d2d !important;
}
.gw-btn.gw-btn--mode-secondary:hover {
  border: 1px solid #2d2d2d !important;
}
.gw-btn.gw-btn--mode-secondary:hover .gw-text {
  color: #2d2d2d !important;
}
.gw-tooltip__content {
  background-color: #2d2d2d !important;
}
                `);
              root.adoptedStyleSheets.push(sheet);
              isFormsInitialized = true;
            }
          }
        }
      }, 500);
    }
    function overrideSummaryStyles() {
      var isInitialized = false;
      setInterval(function() {
        if (isInitialized) {
          return;
        }
        var $root = $('.gw-rv-average-placeholder');
        if ($root.length > 0) {
          var root = $root.get(0).shadowRoot;
          if (root) {
            const sheet = new CSSStyleSheet();
            sheet.replaceSync(`
.gw-rv-average__btn svg {
  display: none !important;
}
.gw-rv-average__btn .gw-rv-average__btn-text {
  text-decoration: none !important;
}
.gw-btn.gw-rv-average__btn {
  gap: 0 !important;
}
            `);
            root.adoptedStyleSheets.push(sheet);
            isInitialized = true;
          }
        }
      }, 500);
    }

    function overrideFaveButtonModal() {
      if (window.customer) {
        return;
      }
      var isInitialized = false;
      setInterval(function() {
        if (isInitialized) {
            return;
        } 
        var $root = $('.gw-wl-save-modal-widget-placeholder');
        if ($root.length > 0) {
          root = $root.get(0).shadowRoot;
          if (root) {
              const sheet = new CSSStyleSheet();
              sheet.replaceSync(`
.gw-modal__content {
  align-items: center !important;
}
form.gw-wl-save-guest-item-form {
  display: none !important;
}
              `);
              root.adoptedStyleSheets.push(sheet);
              isInitialized = true;
          }
        }
      }, 500);
    }

    async function caAddWishlist(e) {
      if (!window.customer) {
        return;
      }
      if (e.currentTarget.dataset.inWishlist === 'true') {
        return;
      }
      if($('#btnAddtocart').attr('disabled') !== undefined) {
        return;
      }
      await fetch('/tools/promoproxy/api/public/ca-add-wishlist', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
    };

    function overrideFavButton($root, lang) {
        var $btnAddToCart = $('#btnAddtocart');
        var root = $root.get(0).shadowRoot;
        var btnEl = root.querySelector('.gw-wl-add-to-wishlist-product-page-widget button');
        var btnTextEl = btnEl.querySelector('.gw-wl-add-to-wishlist-btn__inner').lastElementChild;
        var isExecutedOnce = false;
        if (btnEl && btnTextEl) {
          if (!isExecutedOnce) {
            $root.css('cssText', 'display: block !important');
            btnEl.addEventListener('click', caAddWishlist);
            isExecutedOnce = true;
          }
          if ($btnAddToCart.attr('disabled') === undefined) {
            btnEl.classList.remove('elecboy-oos');
            if (btnEl.dataset.inWishlist === "true") {
              btnTextEl.innerText = lang === 'en'
                ? 'In Wishlist'
                : '已加入喜愛清單';
            } else {
              btnTextEl.innerText = lang === 'en'
                ? 'Add to Wishlist'
                : '加入喜愛清單';
            }
          } else {
            btnEl.classList.add('elecboy-oos');
            if (btnEl.dataset.inWishlist === "true") {
              btnTextEl.innerText = lang === 'en'
                ? 'In Wishlist'
                : '已加入有貨通知';
            } else {
              btnTextEl.innerText = lang === 'en'
                ? 'Notify When In Stock'
                : '有貨通知';
            }
          }
          if ($btnAddToCart.hasClass('hide')) {
            $root.detach().insertAfter('.btn-action');
          } else {
            $root.detach().appendTo('.product-actions');
          }
        }
    }

    function overrideFavButtonStyles() {
      var isInitialized = false;
      var root = null;
      var lang = $('html').attr('lang');
      setInterval(function() {
        var $root = $('.gw-wl-add-to-wishlist-placeholder');
        if (isInitialized) {
            overrideFavButton($root, lang);
            return;
        } 
        if ($root.length > 0) {
            root = $root.get(0).shadowRoot;
            if (root) {
                var btnEl = root.querySelector('.gw-wl-add-to-wishlist-product-page-widget button');
                if (btnEl) {
                  btnEl.addEventListener('click', overrideFaveButtonModal, false);
                  const sheet = new CSSStyleSheet();
                  sheet.replaceSync(`
  .gw-wl-add-to-wishlist-product-page-widget .gw-btn.gw-button.gw-btn--block {
    width: 50px !important;
    height: 40px !important;
    background-color: var(--gw-wl-wishlistButtonSettings-color) !important;
    box-shadow: none !important;
    color: #ffffff !important;
    font-family: Rubik, sans-serif !important;
    border-radius: 4px !important;
  }
  .gw-wl-add-to-wishlist-product-page-widget .gw-btn.gw-button.elecboy-oos {
    border: 0 !important;
    background-color: #3b3c49 !important;
  }
  .gw-wl-add-to-wishlist-btn__inner {
    font-size: var(--gw-font-size-sm) !important;
    font-weight: 400 !important;
    text-transform: uppercase !important;
    @media (max-width: 575px){
      font-size: ${lang === 'en' ? 'var(--gw-font-size-xs)' : 'var(--gw-font-size-sm)'} !important;
    }
  }
  .gw-wl-add-to-wishlist-product-page-widget .gw-btn.gw-button.elecboy-oos .gw-wl-icon {
    width: 0 !important;
  }
  .gw-wl-add-to-wishlist-btn__inner .gw-wl-icon {
    color: #ffffff !important;
  }
  .gw-wl-add-to-wishlist-btn__inner .gw-badge,
  .gw-wl-add-to-wishlist-btn__inner span {
    display: none !important;
  }
  .gw-wl-add-to-wishlist-product-page-widget .gw-btn.gw-button.elecboy-oos {
    width: 160px !important;
    @media (max-width: 420px){
      width: 130px !important;
    }
  }
  .elecboy-oos .gw-wl-add-to-wishlist-btn__inner span {
    display: block !important;
  }
                  `);
                  root.adoptedStyleSheets.push(sheet);
                  isInitialized = true;
                }
            }
        }
      }, 500);
    }

    (function() {
      overrideFavButtonStyles();
      overrideReviewStyles();
      overrideSummaryStyles();
    })();
  }

	async function initHardBundle(event, data) {
		async function fetchProduct(handle) {
			try {
				const resp = await fetch(`/products/${handle}.js`, {
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				},
				});
				if (!resp.ok) {
					throw new Error(`HTTP error! Status: ${response.status}`);
				}
				const json = await resp.json();
				return json;
			} catch (e) {
				console.error(e);
				return null;
			}
		};
		function shouldRender(hardBundle) {
			if (!hardBundle) {
				return false;
			}
			const d = new Date();
			const formatter = new Intl.DateTimeFormat('en-US', {
				timeZone: 'Asia/Hong_Kong',
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
				hour: '2-digit',
				minute: '2-digit',
				second: '2-digit',
				hour12: false // Force 24-hour format
			});
			const parts = formatter.formatToParts(d);
			const map = new Map(parts.map(p => [p.type, p.value]));
			const yyyymmddhhmm = `${map.get('year')}${map.get('month')}${map.get('day')}${map.get('hour')}${map.get('minute')}`;
			if (
				yyyymmddhhmm < hardBundle.startDate ||
				yyyymmddhhmm > hardBundle.endDate
			) {
				return false;
			}
			return true;
		}
		function renderHtml(parentVariant, products) {
			const eligibleSkus = parentVariant.hardBundle.bundledSkus.map(({ sku }) => sku);
			let html = products
				.filter((product) => !!product && product.available)
				.reduce((result, product, index) => {
					const chunkIndex = Math.floor(index / 3);
					if (!result[chunkIndex]) {
						result[chunkIndex] = []; // Start a new chunk
					}
					result[chunkIndex].push(product);
					return result;
				}, [])
				.map((pagedProducts) => {
					const productDivs = pagedProducts.map((product) => {
						const variants = product.variants.filter((variant) => {
							return variant.available && eligibleSkus.includes(variant.sku);
						});
						let variantsSelect = variants.map((variant) => {
							return `
								<option data-sku="${variant.sku}" value="${variant.id}">${variant.title}</option>
							`;
						}).join('');
						variantsSelect = `<select class="${variants.length <= 1 ? 'hide' : ''}">${variantsSelect}</select>`;
						let imgSrc = product.featured_image
							? `${product.featured_image}&width=128`
							: '/cdn/shop/t/136/assets/placeholder.png';
						return `
							<div class="product-container" data-product-id="${product.id}">
								<img src="${imgSrc}" width="64" height="64" loading="lazy" decoding="async">
								<div>
									<div class="div-product-hard-bundle-info">
										<h5><a href="${Shopify.locale === 'en' ? '/en' : ''}/products/${product.handle}">${product.title}</a></h5>
										${variantsSelect}
										<div>
											<span class="price${product.compare_at_price ? ' discounted': ''}">$${parseInt(product.price/100).toLocaleString('en-US')}</span>
											<span class="compare-price${product.compare_at_price ? '': ' hide'}">$${parseInt(product.compare_at_price/100).toLocaleString('en-US')}</span>
										</div>
									</div>
									<div class="div-product-hard-bundle-qty">
										<span class="btn-product-hard-bundle-decrement">-</span>
										<input type="number" class="input-product-hard-bundle-qty" value="0"></input>
										<span class="btn-product-hard-bundle-increment">+</span>
									</div>
								</div>
							</div>
						`;
					});
					return `<li>${productDivs.join('')}</li>`;
				})
				.join('');
			html = `
				<div class="product-hard-bundle">
					<div class="title">購買本商品同時需選購(最少${parentVariant.hardBundle.minQty}件):</div>
					<ul>${html}</ul>
				</div>
			`;
			$('#shopify-section-product-hard-bundle').append(html);
		};
		function attachEvents(parentVariant, products) {
			$('#shopify-section-product-hard-bundle div.product-container').each(function() {
				const $select = $(this).find('select');
				$select.off('change');
				$select.on('change', function() {
				const productId = parseInt($(this).closest('div.product-container').data('product-id'));
				const selectedProduct = products.find((p) => {
					return p.id === productId;
				});
				const selectedVariant = selectedProduct.variants.find((v) => {
					return v.id === parseInt($(this).val());
				});
				$(this).closest('div.product-container').find('.price').html(
					`$${parseInt(selectedVariant.price/100).toLocaleString('en-US')}`
				);
				$(this).closest('div.product-container').find('.compare-price').html(
					`$${parseInt(selectedVariant.compare_at_price/100).toLocaleString('en-US')}`
				).toggleClass('hide', !selectedVariant.compare_at_price);
				});
			}).each(function() {
				const $btn = $(this).find('.btn-product-hard-bundle-decrement');
				$btn.off('click');
				$btn.on('click', function() {
					var $inputEl = $(this).closest('div').find('.input-product-hard-bundle-qty');
					var val = parseInt($inputEl.val());
					val = val > 0 ? val - 1 : 0;
					$inputEl.val(val.toString());
				});
			}).each(function() {
				const $btn = $(this).find('.btn-product-hard-bundle-increment');
				$btn.off('click');
				$btn.on('click', function() {
					var $inputEl = $(this).closest('div').find('.input-product-hard-bundle-qty');
					var val = parseInt($inputEl.val());
					val = val >= 0 ? val + 1 : 1;
					$inputEl.val(val.toString());
				});
			});
		};
		async function init(variant) {
			if (!shouldRender(variant.hardBundle)) {
				return;
			}
			let handles = [...new Set(variant.hardBundle.bundledSkus.map((item) => item.handle))];
			const products = await Promise.all(handles.map(async function(handle) {
				return fetchProduct(handle);
			}));
			variant.hardBundle.bundledSkus.forEach((item) => {
				item.product = products.find((product) => product.handle === item.handle);
			});
			renderHtml(variant, products);
			attachEvents(variant, products);
		}
		var selectedVariant = null;
		if (event) {
			selectedVariant = data.variant;
		} else {
			const $radio0 = $('input[type="radio"][name=option-0]:checked');
			const $radio1 = $('input[type="radio"][name=option-1]:checked');
			const $radio2 = $('input[type="radio"][name=option-2]:checked');
			selectedVariant = productJSON.variants.find((variant) => {
				return (
				(!$radio0.val() || variant.options[0].replaceAll('"', '-') === $radio0.val()) &&
				(!$radio1.val() || variant.options[1].replaceAll('"', '-') === $radio1.val()) &&
				(!$radio2.val() || variant.options[2].replaceAll('"', '-') === $radio2.val())
				);
			});
		}
		await init(selectedVariant);
	}
	return {
		init: init()
	}
};


(function($){
	$(document).ready(function($) {
		ElecboyTheme.pdp();
	});
})(jQuery);
